import { useEffect, useState } from "react";
import { toast } from "sonner";
import { DeviceMobile, Desktop, SignOut } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { api, errMsg, fmtDateTime } from "@/lib/api";

export default function SessionsCard() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/auth/sessions").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const revoke = async (id) => {
    try { await api.delete(`/auth/sessions/${id}`); toast.success("Oturum kapatıldı"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const revokeOthers = async () => {
    try { const { data } = await api.post("/auth/sessions/revoke-others"); toast.success(`${data.revoked} oturum kapatıldı`); load(); } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="panel fade-up p-6" data-testid="sessions-card">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="flex items-center gap-2 font-display text-lg font-bold"><Desktop size={18} /> Aktif Oturumlar</h3>
          <p className="mt-1 text-xs text-muted-foreground">Hesabınıza giriş yapılmış cihazlar. Tanımadığınız bir cihaz varsa kapatın ve şifrenizi değiştirin. Yeni cihazdan girişte e-posta ile bilgilendirilirsiniz.</p>
        </div>
        {rows.length > 1 && <Button variant="outline" size="sm" onClick={revokeOthers} className="shrink-0 rounded-[4px]" data-testid="sessions-revoke-others-button"><SignOut /> Diğerlerini kapat</Button>}
      </div>
      <ul className="mt-4 divide-y border text-sm" data-testid="sessions-list">
        {rows.map((s) => (
          <li key={s.id} className="flex items-center justify-between gap-3 px-3 py-2" data-testid={`session-row-${s.id}`}>
            <div className="flex items-center gap-3">
              {/iphone|android|ipad/i.test(s.device) ? <DeviceMobile size={20} className="text-slate-500" /> : <Desktop size={20} className="text-slate-500" />}
              <div>
                <div className="font-medium">{s.device}{s.current && <span className="ml-2 rounded bg-teal-100 px-1.5 text-[10px] font-bold text-teal-800" data-testid="session-current-badge">Bu cihaz</span>}</div>
                <div className="text-xs text-muted-foreground">{s.ip || "—"} · son görülme {fmtDateTime(s.last_seen_at)} · giriş {fmtDateTime(s.created_at)}</div>
              </div>
            </div>
            {!s.current && <Button variant="ghost" size="sm" onClick={() => revoke(s.id)} className="rounded-[4px] text-red-700 hover:bg-red-50" data-testid={`session-revoke-${s.id}`}>Kapat</Button>}
          </li>
        ))}
        {rows.length === 0 && <li className="px-3 py-3 text-xs text-muted-foreground">Oturum bilgisi bulunamadı.</li>}
      </ul>
    </div>
  );
}
